export default "__VITE_ASSET__598cf952__"